import Flag from "react-world-flags";

import {
  ISO3_TO_ISO2_MAP,
  PAYOUT_WIZARD_COUNTRIES,
} from "@/modules/dashboard/dispersions/constants/dispersions.constants";
import { useCountryLabel } from "@/shared/hooks/useCountryLabel";
import { cn } from "@/shared/lib/utils";
import { formatRail } from "@/shared/utils/railDisplay";

export interface CorridorLabelProps {
  country: string;
  rail: string;
  /** Appends the delivery currency: "Colombia · Bre-B · COP". */
  currency?: string;
  className?: string;
}

/** Flag + country + rail — the way a corridor reads everywhere in the module. Never the provider. */
export function CorridorLabel({ country, rail, currency, className }: CorridorLabelProps) {
  const countryLabel = useCountryLabel();
  const fallback = PAYOUT_WIZARD_COUNTRIES.find((entry) => entry.code === country)?.name ?? country;
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <Flag
        code={ISO3_TO_ISO2_MAP[country] ?? country}
        className="h-3.5 w-5 shrink-0 rounded-[2px] object-cover"
        aria-hidden="true"
      />
      <span className="truncate">
        {countryLabel(country, fallback)} · {formatRail(rail)}
        {currency ? ` · ${currency}` : ""}
      </span>
    </span>
  );
}
